import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SLSParametrosClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async findAll(queries = {}) {
    try {
      return await this.api.get('/parametros', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar os parâmetros');
    }
  }

  async create(data) {
    try {
      const { data: response } = await this.api.post('/parametros', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar o parâmetro');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.api.put(`/parametros/${id}`, data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar o parâmetro');
    }
  }

  async delete(id) {
    try {
      const { data: response } = await this.api.delete(`/parametros/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar o parâmetro');
    }
  }

  async findByDescricao(descricao, exact = false) {
    try {
      const { data } = await this.api.get('/parametros/find', { params: { parametro: descricao, exact } });
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar o parâmetro');
    }
  }
}
